import { Theme } from "@mui/material";
import {
  ChartType,
  FontSpec,
  Tooltip,
  TooltipPositionerFunction,
} from "chart.js";

Tooltip.positioners.cursor = function (_, { x, y }) {
  return {
    x,
    y,
  };
};

declare module "chart.js" {
  interface TooltipPositionerMap {
    cursor: TooltipPositionerFunction<ChartType>;
  }
}

/** Split a label into multiple lines at word boundaries if it exceeds maxLength. */
export function wrapLabel(
  label: string,
  maxLength = 12
): string | string[] {
  if (label.length <= maxLength) return label;
  const words = label.split(" ");
  const lines: string[] = [];
  let current = "";
  for (const word of words) {
    if (current && (current + " " + word).length > maxLength) {
      lines.push(current);
      current = word;
    } else {
      current = current ? current + " " + word : word;
    }
  }
  if (current) lines.push(current);
  return lines;
}

export function getTicks({ typography }: Pick<Theme, "typography">): {
  font: Partial<FontSpec>;
} {
  return {
    font: {
      family: typography.fontFamily,
      size: typography.fontSize,
    },
  };
}
export function getLegendLabels({ typography }: Pick<Theme, "typography">): {
  font: Partial<FontSpec>;
} {
  return {
    font: {
      family: typography.fontFamily,
      size: typography.fontSize,
    },
  };
}

export function getTooltip({ typography }: Pick<Theme, "typography">): {
  bodyFont: Partial<FontSpec>;
  titleFont: Partial<FontSpec>;
  footerFont: Partial<FontSpec>;
} {
  const font = {
    family: typography.fontFamily,
    size: typography.fontSize,
  };
  return {
    bodyFont: font,
    titleFont: font,
    footerFont: font,
  };
}
